import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',

    gap: theme.spacing(3),
  },

  icon: {
    width: 48,
    minWidth: 48,
  },

  address: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },

  info: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
}));
